<template>
  <v-pull-to-refresh @load="reloadPage">
    <AppHeader
      :is_icon="true"
      :is_back="false"
      :title="''"
      type="none"
      @header-action-click="headerActionClick"
    />
    <div class="home-timeline">
      <div class="page">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-8">
              <div v-if="items">
                <div ref="grid" class="grid-container">
                  <div class="grid-item" v-for="(item, i) in items" :key="i">
                    <div class="card">
                      <img
                        :src="item.img"
                        class="card-img"
                        style="width: 100%; height: auto"
                      />
                      <div class="card-body">
                        <h5 class="card-title">{{ item.title }}</h5>
                        <div>
                          <span class="badge text-bg-kinkyer">a</span>
                          <span class="badge text-bg-kinkyer">Primary</span>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
              <div class="text-center" style="padding-top: 50px" v-else>
                <VueSpinnerDots size="50" color="#784ba0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter :index="7" />
  </v-pull-to-refresh>
</template>

<script>
import { VPullToRefresh } from "vuetify/labs/VPullToRefresh";
import AppHeader from "@/components/HeaderView.vue";
import AppFooter from "@/components/FooterViwe.vue";

export default {
  data() {
    return {
      items: [
        {
          title: "1なまえ",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhgzZHB1rERuCUZyinMSW2eD8dMw3abOn3ggR3DPq5EazEUmw7JqsouRTzqKvRcKWozBo96rwTKjlpZfRd7zYTjuk1Qrveh_Xv-sPDbDp-gl64PUfJurYI1Nq-o9JKua89ZOjtOyVDa86c/s800/showroom_adviser_guide.png",
        },
        {
          title: "2タイトル",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiRuu0RWoeHs26-kJWDLyILcJZ9OljBuc_LyatexrDqGsYOBKNqKJWrt_jKhFATb1jmj124nhh4vTprkPzcRYemzFuSxbCR9cGFomOZx-vnOwQ5a16_4TmbjRWUolmtkNHg_d_5h-BtyvoTMJCvJ6ZmiiiSyu_0RfsbAStBrMaoUm8HN6NFJHIi-Lv8f0hh/s790/bird_fukurou_run.png",
        },
        {
          title: "3商品名",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjr0S3mzMU67AXb7DjRB6M5n3JuiCmpxg_VIb5GET-E523onomwr-ZcCjnDpLWMzyos9LVApseZx6Ryn-6OzDUdcMUK0_r7MliNoVjVwmIzpYVIQ5ZJaU8KTiANwHBO6lJo6WjGcMV0-egF/s800/aroma_spray.png",
        },
        {
          title: "4なまえ",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhgzZHB1rERuCUZyinMSW2eD8dMw3abOn3ggR3DPq5EazEUmw7JqsouRTzqKvRcKWozBo96rwTKjlpZfRd7zYTjuk1Qrveh_Xv-sPDbDp-gl64PUfJurYI1Nq-o9JKua89ZOjtOyVDa86c/s800/showroom_adviser_guide.png",
        },
        {
          title: "5お店の名前",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhoh4Psk_LJvcGDri5FwvUOpsfJ2sjxXvRZWHGkdDFaDkz4G7bLIywKgDk0mmytneeujZyjqlMaEEQqrlTk2loGdCqywOK9XxggNphcTZYTXBNElvcepHZ0i1xBT5EgH0QC2Fi1AtzZYnQu/s1600/virus_hisessyoku_door_opener_door.png",
        },
        {
          title: "6お店の名前",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhoh4Psk_LJvcGDri5FwvUOpsfJ2sjxXvRZWHGkdDFaDkz4G7bLIywKgDk0mmytneeujZyjqlMaEEQqrlTk2loGdCqywOK9XxggNphcTZYTXBNElvcepHZ0i1xBT5EgH0QC2Fi1AtzZYnQu/s1600/virus_hisessyoku_door_opener_door.png",
        },
        {
          title: "7お店の名前",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhoh4Psk_LJvcGDri5FwvUOpsfJ2sjxXvRZWHGkdDFaDkz4G7bLIywKgDk0mmytneeujZyjqlMaEEQqrlTk2loGdCqywOK9XxggNphcTZYTXBNElvcepHZ0i1xBT5EgH0QC2Fi1AtzZYnQu/s1600/virus_hisessyoku_door_opener_door.png",
        },
        {
          title: "8なまえ",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhgzZHB1rERuCUZyinMSW2eD8dMw3abOn3ggR3DPq5EazEUmw7JqsouRTzqKvRcKWozBo96rwTKjlpZfRd7zYTjuk1Qrveh_Xv-sPDbDp-gl64PUfJurYI1Nq-o9JKua89ZOjtOyVDa86c/s800/showroom_adviser_guide.png",
        },
        {
          title: "9クリエイター",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj4Q48CPeOmuilrOBVjPT_EfD13SbWslesiqVfQ2A9ut1HEB80L63e84kw_TdEiNlbc5-icscwD5UKJs55pmzZL55ox0hHwhCsAtAsz1zJJbXHZZui4t2fz0TUq_u7k5vinVgA2bbW3Jkqc/s800/jitensya_unten_ryoute.png",
        },
        {
          title: "10なまえ",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhgzZHB1rERuCUZyinMSW2eD8dMw3abOn3ggR3DPq5EazEUmw7JqsouRTzqKvRcKWozBo96rwTKjlpZfRd7zYTjuk1Qrveh_Xv-sPDbDp-gl64PUfJurYI1Nq-o9JKua89ZOjtOyVDa86c/s800/showroom_adviser_guide.png",
        },
        {
          title: "11クリエイター",
          img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj4Q48CPeOmuilrOBVjPT_EfD13SbWslesiqVfQ2A9ut1HEB80L63e84kw_TdEiNlbc5-icscwD5UKJs55pmzZL55ox0hHwhCsAtAsz1zJJbXHZZui4t2fz0TUq_u7k5vinVgA2bbW3Jkqc/s800/jitensya_unten_ryoute.png",
        },
      ],
    };
  },
  components: {
    AppHeader,
    AppFooter,
    VPullToRefresh,
  },
  mounted() {
    // Masonry初期化
    this.$nextTick(() => {
      const Masonry = window.Masonry; // ★ これでOK

      new Masonry(this.$refs.grid, {
        itemSelector: ".grid-item",
        columnWidth: ".grid-item",
        percentPosition: true,
      });
    });
  },
};
</script>

<style scoped>
.home-timeline {
  animation: fadeIn 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  min-height: 100%;
}
.page {
  padding-top: 60px;
  padding-bottom: 200px;
}

.grid-container {
  position: relative;
  display: block;
}

.text-bg-kinkyer {
  color: #fff;
  background-color: #784ba0;
  margin-right: 5px;
}

.grid-item {
  width: 50%;
  float: left;
  padding: 0 10px;
}
</style>
